/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Premium_Discount_OffInputs */

const en_premium_discount_off = /** @type {(inputs: Premium_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% OFF`)
};

const es_premium_discount_off = /** @type {(inputs: Premium_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% DE DESCUENTO`)
};

/**
* | output |
* | --- |
* | "{percent}% OFF" |
*
* @param {Premium_Discount_OffInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_discount_off = /** @type {((inputs: Premium_Discount_OffInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Discount_OffInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_discount_off(inputs)
	return en_premium_discount_off(inputs)
});